module.exports = __webpack_public_path__ + "static/media/winner_3.1816a374.png";